import CustomButton from "components/CustomButton/CustomButton";
import StopIcon from "icons/StopIcon";
import { isPastSchedule } from "utils/date";

const CancelReservationButton = ({
	reservation: {
		finalized, schedule
	}, openDialogCancelReservation
}) => {
	const disabled = finalized || isPastSchedule({ date: schedule.date, minutes: schedule.timeStart })
	return (
		<CustomButton 
			width="100%"
			icon={<StopIcon/>} 
			variant="secondary"
			text="Cancelar reserva"
			disabled={disabled}
			onClick={openDialogCancelReservation}/>
	);
}

export default CancelReservationButton;